// extracted by mini-css-extract-plugin
export default {"monthSummary":"MonthSummary_monthSummary__KRW+R","card":"MonthSummary_card__80dNh"};